export default "/images/bacbd7d421dee4cbd944a259f5dba1e6.avif";